import type {
    CreateSocketEventBaseParams,
    SocketEventBase,
    SocketEventType} from "@@/shared/socket-events/socket-event-base";
import {
    createSocketEventBase
} from "@@/shared/socket-events/socket-event-base";
import type { OrderSocketEventData } from "./order-socket-event-data";

type OrderSocketEventNamespace = "order";
type OrderSocketEventBaseType<SpecificType extends string = string> =
    SocketEventType<OrderSocketEventNamespace, SpecificType>;
type OrderSocketEventBase<
    SpecificType extends string = string,
    EventData extends Record<string, unknown> | undefined = undefined
> = SocketEventBase<
    OrderSocketEventNamespace,
    SpecificType,
    OrderSocketEventData<EventData>
>;

const createOrderSocketEventBase = <
    SpecificType extends string = string,
    EventData extends Record<string, unknown> | undefined = undefined
>(
    params: CreateSocketEventBaseParams<
        OrderSocketEventNamespace,
        SpecificType,
        OrderSocketEventData<EventData>
    >
) =>
    createSocketEventBase<
        OrderSocketEventNamespace,
        SpecificType,
        OrderSocketEventData<EventData>
    >(params);

export type { OrderSocketEventBase, OrderSocketEventBaseType };
export { createOrderSocketEventBase };
